import { render, staticRenderFns } from "./CreateMedia.vue?vue&type=template&id=ec68891e&scoped=true"
import script from "./CreateMedia.vue?vue&type=script&lang=js"
export * from "./CreateMedia.vue?vue&type=script&lang=js"
import style0 from "./CreateMedia.vue?vue&type=style&index=0&id=ec68891e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec68891e",
  null
  
)

export default component.exports